import React, { useState } from "react";
import "../../assets/styles/auth/auth.css";
import Icon from "../../components/ui/icon";
import { NavLink } from "react-router-dom";
import { useToast } from "../../context/toastContext";
import axios from "axios";
import DOMPurify from "dompurify";
import HorizontalLogo from '../../assets/logos/horizontal-logo.png';

const ForgetPasswordPage = () => {
    const [isTCChecked, setisTCChecked] = useState(false);
    const [isForgetBtnD, setIsForgetBtnD] = useState(false);
    const [emailID, setEmailID] = useState("");
    const showToast = useToast();

    const sanitizeInput = (value) => DOMPurify.sanitize(value);

    const handelLoginBtn = () => {
        if (isForgetBtnD) return;
        setIsForgetBtnD(true);

        const sanitizedEmail = sanitizeInput(emailID);
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (sanitizedEmail.length <= 0) {
            document.getElementById("emailID").focus();
            navigator.vibrate([200]);
            setIsForgetBtnD(false);
            return;
        }

        if (!emailRegex.test(sanitizedEmail)) {
            document.getElementById("emailID").focus();
            navigator.vibrate([200, 100, 200]);
            setIsForgetBtnD(false);
            return;
        }

        if (!isTCChecked) {
            showToast({
                status: "error",
                message: "Accept Our Conditions.",
            });
            setIsForgetBtnD(false);
            return;
        }

        axios
            .post(`${window.location.origin === 'http://localhost:3000' ? 'http://localhost:5500' : window.location.origin}/api/password/request-reset`, {
                email: sanitizedEmail,
            })
            .then((response) => {
                if (response.data.status) {
                    showToast({
                        status: "success",
                        message: response.data?.message || "Reset Url Sent Successful.",
                    });
                } else {
                    showToast({
                        status: "error",
                        message: response.data?.message || "Url Sending Failed.",
                    });
                }
            })
            .catch((error) => {
                showToast({
                    status: "error",
                    message: error.response?.data?.message || "Something went wrong.",
                });
            })
            .finally(() => {
                setIsForgetBtnD(false);
            });
    };

    return (
        <div className="login__page">
            <div className="company-info">
                <img src={HorizontalLogo} alt="Company Logo" />
                <h1>Swift Digital Ads</h1>
                <p>
                    Someone who not just help you grow but also help you track your growth
                </p>
            </div>

            <div className="main-content">
                <h1>Forgot Password</h1>
                <p>Enter your registered email and we’ll help you reset your password.</p>

                <div className="login-form">
                    <div className="inp-box">
                        <label htmlFor="emailID">Email ID</label>
                        <input
                            value={emailID}
                            onChange={(e) => setEmailID(e.target.value)}
                            type="email"
                            id="emailID"
                            placeholder="eg: jhon@gmail.com"
                        />
                    </div>
                </div>

                <div className="tc-sec">
                    <div
                        onClick={() => setisTCChecked(!isTCChecked)}
                        className={`tc-box ${isTCChecked ? "checked" : ""}`}
                    >
                        <Icon name="Check" />
                    </div>
                    <p>I accept <a href="https://swiftdigitalads.com/doc/terms" target="_blank" rel="noreferrer">terms & conditions</a> and <a href="https://swiftdigitalads.com/doc/privacy" target="_blank" rel="noreferrer">privacy policy</a>.</p>
                </div>

                <button
                    className="login-btn"
                    onClick={handelLoginBtn}
                    disabled={isForgetBtnD}
                >
                    {isForgetBtnD ? (
                        <>
                            Updateing... <Icon name="ArrowPath" className="icon-spin" />
                        </>
                    ) : (
                        <>
                            Reset Password <Icon name="ChevronRight" />
                        </>
                    )}
                </button>

                <div className="divider">
                    <div className="line"></div>
                    <p className="text">Quick Links</p>
                </div>

                <div className="QuickLinks">
                    <NavLink to="/auth/login">Login</NavLink>
                    <NavLink to="/auth/register">Register</NavLink>
                </div>
            </div>
        </div>
    );
};

export default ForgetPasswordPage;